<div class="card" [ngClass]="{'expandable': allowExpand, 'expanded': isExpanded}" (click)="toggleExpand()">
  <div class="card-header">
    <div class="photo">
      <img
        *ngIf="member?.avatar"
        [src]="getAvatar(member?.avatar)"
        [matTooltip]="member?.name"
        matTooltipClass="tooltip"
      />

      <img
        *ngIf="!member?.avatar"
        [matTooltip]="member?.name"
        matTooltipClass="tooltip"
        src="../../../assets/icons/default-user-icon-profile.png"
      />
    </div>
    <div class="details">
      <p class="name">{{ member?.name }}</p>
      <div class="action-buttons" *ngIf="showActions">
        <button (click)="$event.stopPropagation()">
          <img
            src="../../../assets/icons/visibility_black_24dp.svg"
            matTooltip="Vizualizar"
            [routerLink]="['/membro/vizualizar/' + member?.id]"
          />
        </button>
        <button class="btn-edit" (click)="$event.stopPropagation()">
          <img src="../../../assets/icons/edit.svg" matTooltip="Editar" [routerLink]="['/membro/' + member?.id]" />
        </button>
        <button (click)="$event.stopPropagation()">
          <img src="../../../assets/icons/delete.svg" matTooltip="Remover" (click)="delete(member?.id, member?.name)" />
        </button>
      </div>
    </div>
  </div>

  <div class="card-body" *ngIf="isExpanded" (click)="$event.stopPropagation()">
    <mat-progress-bar *ngIf="isLoadingFunctions" mode="indeterminate"></mat-progress-bar>
    <div class="functions-container" *ngIf="!isLoadingFunctions">
      <div class="functions-title">Funções atribuídas:</div>
      
      <mat-accordion *ngIf="memberFunctions.length > 0" multi="true">
        <mat-expansion-panel *ngFor="let func of memberFunctions" class="function-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ func.description || func.name }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="roles-container">
            <div class="role-item" *ngFor="let role of func.roles">
              <div class="role-entity">
                <strong>{{ role.entity?.name || 'Sem entidade' }}</strong>
                <span class="role-name">({{ role.name }})</span>
              </div>
              <div class="role-permissions">
                <span class="perm-badge" [class.active]="role.view">Ver</span>
                <span class="perm-badge" [class.active]="role.create">Criar</span>
                <span class="perm-badge" [class.active]="role.edit">Editar</span>
                <span class="perm-badge" [class.active]="role.delete">Excluir</span>
              </div>
            </div>
            <span *ngIf="!func.roles || func.roles.length === 0" class="no-functions">
              Nenhuma role vinculada a essa função.
            </span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <span *ngIf="memberFunctions.length === 0" class="no-functions">Nenhuma função atribuída.</span>
    </div>
  </div>
</div>
